export interface DistrModerationState {
  bulkDistrList: BulkDistrItem[],
  bulkDistrItem?: BulkDistrItem,
}

export class BulkDistrItem {
  id?: number;
  create_date?: string;
  partner?: string;
  originator?: string;
  transport?: string;
  recipients_count?: number;

  sender?: string;
  subject?: string;
  message?: string;

  commentary?: string;
}

export class BulkDistrItemImpl implements BulkDistrItem {
}

export class EmailBulkDistrItemImpl extends BulkDistrItem {
  attached_files?: FileItem[];
}

export class PushBulkDistrItemImpl extends BulkDistrItem {
  application?: string;
  title?: string;
  content?: string;
}

export class ViberBulkDistrItemImpl extends BulkDistrItem {
  image_link?: string;
  button_name?: string;
  button_link?: string;
  attachment_file_id?: string | null;
}

export class WhatsAppBulkDistrItemImpl extends BulkDistrItem {
  image_link?: string;
  attached_files?: FileItem[];
}

export class CustomBulkDistrItemImpl extends BulkDistrItem {
  image_link?: string;
  button_name?: string;
  button_link?: string;
  custom_parameters?: { name?: string, value?: string | undefined } [];
}

export interface FileItem {
  id?: number,
  name: string,
  base64: string
}

export interface BulkDistrFilter {
  date_from: string,
  date_to: string,
  partner?: string,
  originator?: string,
  transport?: string,
  recipients_count?: number,
}

export class BulkDistrFilterImpl implements BulkDistrFilter {
  date_to: string;
  date_from: string;

  partner = undefined;
  originator = undefined;
  transport = undefined;
  recipients_count = undefined;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
}
